if (!customElements.get('wls-info')) {
    class WLSInfo extends HTMLElement {
        constructor() {
            super();

            this.classes = {
                slider: 'js-wls-info-slider',
                list: 'splide__list',
                item: 'splide__slide',
                dots: 'js-wls-splide-navigation-dots',
                arrows: 'js-wls-splide-navigation-arrows',
                arrowPrev: 'js-wls-splide-navigation-arrow-prev',
                arrowNext: 'js-wls-splide-navigation-arrow-next',
                navigation: 'js-wls-splide-navigation',
            };

            this.elements = {
                slider: this.querySelector(`.${this.classes.slider}`),
                list: this.querySelector(`.${this.classes.list}`),
                items: this.querySelectorAll(`.${this.classes.item}`),
                navigation: this.querySelector(`.${this.classes.navigation}`),
            };

            this.resizeHandler = this.handleResize.bind(this);
        }

        connectedCallback() {
            if (this.checkIfEmpty()) return;
            this.init();
            window.addEventListener('resize', this.resizeHandler);
        }

        disconnectedCallback() {
            if (this.splide) {
                this.splide.destroy(true);
                this.splide = null;
            }

            window.removeEventListener('resize', this.resizeHandler);

            if (this.resizeTimeout) {
                clearTimeout(this.resizeTimeout);
            }
        }

        checkIfEmpty() {
            const listInner = this.elements.list;

            if (!listInner || !listInner.children.length) {
                this.style.display = 'none';
                return true;
            }

            return false;
        }

        init() {
            if (!this.shouldInitialize()) return;
            this.initializeSplide();
        }

        shouldInitialize() {
            if (!this.elements.slider || !this.elements.items.length) return false;

            const width = window.innerWidth;
            const slidesCount = this.elements.items.length;

            if (slidesCount <= 1 && width < 1199) {
                this.elements.navigation.style.display = 'none';
                return false;
            }

            if (slidesCount <= 4 && width >= 1199) {
                this.elements.navigation.style.display = 'none';
                this.elements.list.style.gap = '20px';
                return false;
            }

            this.elements.navigation.style.display = '';
            return true;
        }

        handleResize() {
            if (this.resizeTimeout) {
                clearTimeout(this.resizeTimeout);
            }

            this.resizeTimeout = setTimeout(() => {
                const shouldInit = this.shouldInitialize();

                if (shouldInit && !this.splide) {
                    this.initializeSplide();
                } else if (!shouldInit && this.splide) {
                    this.splide.destroy(true);
                    this.splide = null;
                } else if (this.splide) {
                    this.createPagination();
                }
            }, 300);
        }

        initializeSplide() {
            this.prevBtn = this.querySelector(`.${this.classes.arrowPrev}`);
            this.nextBtn = this.querySelector(`.${this.classes.arrowNext}`);
            this.paginationEl = this.querySelector(`.${this.classes.dots}`);

            this.splide = new Splide(this.elements.slider, {
                type: 'slide',
                perPage: 1,
                perMove: 1,
                gap: '16px',
                drag: true,
                arrows: false,
                pagination: false,
            });

            this.splide.on('mounted', () => {
                this.createPagination();
                this.bindArrows();
            });

            this.splide.on('move', () => {
                this.updatePagination();
            });

            this.splide.mount();
        }

        bindArrows() {
            if (this.prevBtn) {
                this.prevBtn.addEventListener('click', () => this.splide.go('<'));
            }

            if (this.nextBtn) {
                this.nextBtn.addEventListener('click', () => this.splide.go('>'));
            }
        }

        getPaginationCount() {
            const slidesCount = this.splide.length;
            const isDesktop = window.innerWidth >= 1199;

            if (isDesktop) {
                return Math.max(slidesCount - 2, 1);
            }

            return slidesCount;
        }

        createPagination() {
            if (!this.paginationEl || !this.splide) return;

            this.paginationEl.innerHTML = '';
            this.paginationDots = [];

            const dotsCount = this.getPaginationCount();

            for (let i = 0; i < dotsCount; i++) {
                const dot = document.createElement('button');
                dot.className = 'wls-reviews__dot';

                dot.addEventListener('click', () => {
                    this.splide.go(i);
                });

                this.paginationEl.appendChild(dot);
                this.paginationDots.push(dot);
            }

            this.updatePagination();
        }

        updatePagination() {
            if (!this.paginationDots || !this.splide) return;

            const isDesktop = window.innerWidth >= 1199;
            let activeIndex = this.splide.index;

            if (isDesktop) {
                activeIndex = Math.min(
                    activeIndex,
                    this.paginationDots.length - 1
                );
            }

            this.paginationDots.forEach((dot, index) => {
                dot.classList.toggle('is-active', index === activeIndex);
            });
        }
    }

    customElements.define('wls-info', WLSInfo);
}
